import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Replace = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      clipRule="evenodd"
      d="M4.00001 2.66659H2.66667V6.66659H2.8347H4.22761H6.66667V5.33325H5.01853C5.75096 4.51492 6.81534 3.99992 8 3.99992C10.2091 3.99992 12 5.79078 12 7.99992H13.3333C13.3333 5.0544 10.9455 2.66659 8 2.66659C6.40708 2.66659 4.97726 3.36493 4.00001 4.47215L4.00001 2.66659ZM11.7724 9.33325H9.33334V10.6666H10.9815C10.2491 11.4849 9.18467 11.9999 8 11.9999C5.79087 11.9999 4.00001 10.2091 4.00001 7.99992H2.66667C2.66667 10.9454 5.05449 13.3333 8 13.3333C9.59293 13.3333 11.0227 12.6349 12 11.5277V13.3333H13.3333V9.33325H13.1653H11.7724Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Icon>
));

export default Replace;
